import React, { Fragment } from "react";
import styled from "styled-components";
import { Match } from "@reach/router";
import { View, Link } from "./components";
import friendlyUrl from "slug";
import { scrollDown } from "./App";

import professions, { excludeFromMenu } from "./professions";

const Container = styled(View).attrs(() => ({ pb: 3 }))`
  display: flex;
  justify-content: space-between;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const ProfessionsContainer = styled(View)`
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;
  width: 100%;
  min-width: 760px;
  & a:not(:last-child):after {
    content: " /";
    margin-right: 0.5em;
  }
  @media (max-width: 874px) {
    min-width: 700px;
    & a {
      font-size: 0.8rem;
    }
  }
`;

export default () => (
  <Container>
    <ProfessionsContainer>
      <Match path={"/artists/:profession"}>
        {({ match }) => (
          <Fragment>
            {professions
              .filter((profession) => !excludeFromMenu.includes(profession))
              .map((profession, index) => (
                <Link
                  to={`/artists/${friendlyUrl(profession)}`}
                  isCurrent={
                    (!match && index === 0) ||
                    (match && match.profession === friendlyUrl(profession))
                  }
                  onClick={() => scrollDown()}
                >
                  {profession}
                </Link>
              ))}
          </Fragment>
        )}
      </Match>
    </ProfessionsContainer>
  </Container>
);
